// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"759":"b75e946e544b4b8d","3298":"58e766021c076f48"}[chunkId] + ".js";
};